import React, { useContext, useEffect, useState } from "react";
import { http } from "../services/httpService";
import config from "../services/config.json";
import { context } from "../context/context";
import PlaceCommentsTable from "../components/Place/PlaceCommentsTable";
import { Button } from "antd";
import { Link, NavLink } from "react-router-dom";

const PlaceComments = () => {
    // state
    const [comments, setComments] = useState([]);
    const [title, setTitle] = useState();
    const [loading, setLoading] = useState(false);
    // context
    const { selectedPlaceId } = useContext(context);
    // useEffect
    useEffect(() => {
        setLoading(true);
        http.get(`${config.parkopoloApi}/api/Place/${selectedPlaceId}`)
            .then((res) => {
                setLoading(false);
                setTitle(res.data.result.title);
                setComments(res.data.result.comment);
            })
            .catch((err) => {
                setLoading(false);
                console.log(err);
            });
    }, [selectedPlaceId]);

    return (
        <>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
                <h3>کامنت های {title}</h3>
                <NavLink to="/place">
                    <Button type="primary" danger>بازگشت</Button>
                </NavLink>
            </div>
            <PlaceCommentsTable comments={comments} loading={loading} />
        </>
    );
};

export default PlaceComments;
